import {ChangeDetectorRef, Component, Input, OnChanges, OnInit} from '@angular/core';
import {ParticipantsService} from "../service/participants.service";
import {Item} from "../../../../models/Item";
import {Observable} from "rxjs";
import {UiAdapterService} from "../../../../services/uiAdapterService/ui-adapter.service";
import {AbstractObserver} from "../../../AbstractObserver/AbstractObserver";
declare const Yiit;

@Component({
  selector: 'app-item-participant',
  templateUrl: './item-participant.component.html',
  styleUrls: ['./item-participant.component.scss']
})
export class ItemParticipantComponent extends AbstractObserver implements OnInit, OnChanges {
  @Input() item:Item;

  public participantsList: string[];
  private currentParticipantGroups: string[] = [];
  public Yiit = Yiit;

  constructor(private participantsService: ParticipantsService, private ui: UiAdapterService, private cd: ChangeDetectorRef) {
    super();
  }

  ngOnChanges(changes): void {
    this.cd.detectChanges();
  }

  ngOnInit() {
    this.participantsService.participantList.subscribe((list: string[])=>{
      this.participantsList = list;
      console.log('this.participantsList', this.participantsList);
    });

    this.currentParticipantGroups = this.getParticipantGroupsFromItem();

    this.subscribeToObservable(this.item.getSubject('participant_updated'), (inputVal)=>{
      this.currentParticipantGroups = this.getParticipantGroupsFromItem();
      this.cd.detectChanges();
    });

    this.subscribeToObservable(this.ui.selectedItem$, ()=>{
      this.currentParticipantGroups = this.getParticipantGroupsFromItem();
      this.cd.detectChanges();
    });
  }

  public isParticipantAvailable(){
    return this.participantsList && this.participantsList.length > 0;
  }

  getParticipantGroupsFromItem():string[] {
    return this.participantsService.getParticipantGroupsFromItem(this.item);
  };

  public isInParticipantGroup(group):boolean{
    return this.currentParticipantGroups.includes(group);
  }

  changeParticipant(val){
      if (this.isInParticipantGroup(val)){
        this.currentParticipantGroups.splice(this.currentParticipantGroups.indexOf(val), 1);
      }
      else{
        this.currentParticipantGroups.push(val);
      }

      this.participantsService.updateItemParticipantValue(this.item, this.currentParticipantGroups);
  }

}
